import { ModifierFunction } from './base'

const spring = (() => {
}) as unknown as ModifierFunction<any, any, 'spring'>

spring._defaults = {}

export default spring
